import { useIsAuthenticated } from "@azure/msal-react";
import { initializeHeaderInfo } from "../../redux/action";
import { MenuOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { msalInstance } from "../../config/api.config";
import React, { useEffect, useState } from "react";
import { requestToken } from "../../auth/AuthServices";
import { callMsGraph } from "../../utils/graph";
import { useLocation, useNavigate } from "react-router";
import {
  Button,
  Drawer,
  Dropdown,
  Space,
  Divider,
  Menu,
  PageHeader,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Confirm } from "notiflix";
import { connect } from "react-redux";
import "./styles.css";

import { Detector } from "react-detect-offline";

function Navbar(props) {

  const [drawerVisible, setDrawerVisible] = useState(false);
  const isAuthenticated = useIsAuthenticated();

  const navigate = useNavigate();
  const location = useLocation();

  function Logout() {
    Confirm.show(
      "Logout",
      "Are you sure want Logout Session?",
      "Yes",
      "No",
      () => {
        handleLogout();
      },
      {}
    );
  }

  async function RequestToken() {

    const token = await requestToken(false);

    if (token) {
      try {
        const response_graph = await callMsGraph(token);
        props.setSession(response_graph);
        localStorage.setItem("session_info", JSON.stringify(response_graph));
      } catch (error) {
        console.warn("Failed to get user info", error);
      }
    }
  }
  
  function handleLogout() {
    // Bersihin local storage / redux kalau perlu
    localStorage.clear();

    msalInstance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }
  function codeCompany() {
    const sessionData = localStorage.getItem("session_signin");
    try {
      return sessionData ? JSON.parse(sessionData).company.code : "-";
    } catch {
      return "-";
    }
  }

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={Logout}>
        <a>Logout</a>
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    if (isAuthenticated) {
      const getSession = props.session ? props.session : {};
      if (
        Object.keys(getSession).length === 0 &&
        Object.getPrototypeOf(getSession) === Object.prototype
      ) {
        const storedSession = localStorage.getItem("session_info");
        if (storedSession) {
          props.setSession(JSON.parse(storedSession));
        } else {
          RequestToken();
        }
      }
    }
  }, [isAuthenticated]);

  const handleBack = () => {
    const preferHistoryBack = Boolean(location.state?.preferHistoryBack);
    const backTo = location.state?.backTo || props.navigate;

    if (preferHistoryBack && typeof window !== "undefined" && window.history.length > 1) {
      navigate(-1);
      return;
    }

    if (backTo) {
      navigate(backTo);
    }
  };

  return (
    <>
      <nav className="navbar navbar-light bg-light">
        <div className="container-fluid">
          <PageHeader
            className="site-page-header"
            onBack={handleBack}
            title={props.title}
            subTitle={props.subtitle}
            backIcon={props.back ? <ArrowLeftOutlined /> : ""}
          />
          <div className="d-flex align-items-center d-lg-none d-sm-flex">
            <Detector
              render={({ online }) => (
                <div
                  className="status-indicator"
                  style={{ marginRight: "10px" }}
                  title={online ? "Online" : "Offline Mode"}
                >
                  <span className={`status-ping ${online ? 'online' : ''}`} />
                  <span className={`status-dot ${online ? 'online' : 'offline'}`} />
                </div>
              )}
            />
            {!navigator.onLine && (
              <span style={{ fontSize: "12px", color: "#ff6b6b", marginRight: "10px" }}>
                Offline
              </span>
            )}
          </div>
          {/* toggle */}
          <Button
            className="d-lg-none align-items-center"
            type="primary"
            icon={<MenuOutlined />}
            onClick={showDrawer}
          />

          {/* RIGHT */}
          <div className="d-flex align-items-center d-none d-lg-flex">
            <Detector
              render={({ online }) => (
                <div
                  className="status-indicator"
                  style={{ marginRight: "30px" }}
                  title={online ? "Online" : "Offline Mode"}
                >
                  <span className={`status-ping ${online ? 'online' : ''}`} />
                  <span className={`status-dot ${online ? 'online' : 'offline'}`} />
                </div>
              )}
            />
            <Dropdown overlay={menu} trigger={["click"]}>
              <div className="profile-link">
                <Space>
                  <div className="profile-section d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="profile-icon"
                      style={{ color: "#7b809a" }}
                    />
                    <div className="mx-3" style={{ fontSize: "9px" }}>
                      {props.session?.displayName || "User Name"}
                      <br />
                      {props.session?.userPrincipalName || "user@email.com"}
                    </div>
                  </div>
                </Space>
              </div>
            </Dropdown>
          </div>

          <Drawer
            title=""
            width={200}
            height={100}
            placement="right"
            onClose={closeDrawer}
            visible={drawerVisible}
          >
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <span style={{ fontSize: "14px" }}>{codeCompany()}</span>
              </li>
            </ul>
            <Divider
              style={{
                borderWidth: 2,
              }}
            />
            <div className="d-flex align-items-center">
              <Dropdown overlay={menu} trigger={["click"]}>
                <div className="profile-link">
                  <Space>
                    <div className="profile-section d-flex align-items-center">
                      <FontAwesomeIcon
                        icon={faUser}
                        className="profile-icon"
                        style={{ color: "#7b809a" }}
                      />
                      <div
                        className="mx-3"
                        style={{
                          fontSize: "10px",
                          // letterSpacing: "1px",
                        }}
                      >
                        {props.session?.displayName || "User Name"}
                        <br />
                        {props.session?.userPrincipalName || "user@email.com"}
                      </div>
                    </div>
                  </Space>
                </div>
              </Dropdown>
            </div>
          </Drawer>
        </div>
      </nav>
    </>
  );
}

const reduxState = (state) => ({
  session: state.session_info,
});

const reduxDispatch = (dispatch) => ({
  setSession: (data) => dispatch(initializeHeaderInfo(data)),
});

export default connect(reduxState, reduxDispatch)(Navbar);
